import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";

export const TitleListRouteResolver = async function (to: Route, from: Route, next: Function) {
	const titleListModule = getModule(TitleListState);
	const actions: Promise<void>[] = [];
	if (!titleListModule.languageSkills.length) {
		actions.push(titleListModule.fetchLanguageSkills());
	}
	if (!titleListModule.levels.length) {
		actions.push(titleListModule.fetchVcsLevels());
	}
	await Promise.all(actions);
	// clear the persisted grid data
	titleListModule.changePersistedData();
	next();
};
